import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'puntoAtencion',
    loadChildren: () => import('./punto-atencion/punto-atencion.module').then( m => m.PuntoAtencionPageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'base-controller',
    loadChildren: () => import('./base-controller/base-controller.module').then( m => m.BaseControllerPageModule)
  },
  {
    path: 'censo',
    loadChildren: () => import('./censo/censo.module').then( m => m.CensoPageModule)
  },
  {
    path: 'detalle-pabellon',
    loadChildren: () => import('./detalle-pabellon/detalle-pabellon.module').then( m => m.DetallePabellonPageModule)
  },
  {
    path: 'listado-evoluciones',
    loadChildren: () => import('./listado-evoluciones/listado-evoluciones.module').then( m => m.ListadoEvolucionesPageModule)
  },
  {
    path: 'detalle-evolucion',
    loadChildren: () => import('./detalle-evolucion/detalle-evolucion.module').then( m => m.DetalleEvolucionPageModule)
  },
  {
    path: 'crear-evoluciones',
    loadChildren: () => import('./crear-evoluciones/crear-evoluciones.module').then( m => m.CrearEvolucionesPageModule)
  },
  {
    path: 'busqueda-global',
    loadChildren: () => import('./busqueda-global/busqueda-global.module').then( m => m.BusquedaGlobalPageModule)
  },
  {
    path: 'historia-clinica',
    loadChildren: () => import('./historia-clinica/historia-clinica.module').then( m => m.HistoriaClinicaPageModule)
  },
  {
    path: 'opciones-hc-poppover',
    loadChildren: () => import('./opciones-hc-poppover/opciones-hc-poppover.module').then( m => m.OpcionesHcPoppoverPageModule)
  },
  {
    path: 'listar-ordenes-procedimientos',
    loadChildren: () => import('./listar-ordenes-procedimientos/listar-ordenes-procedimientos.module').then( m => m.ListarOrdenesProcedimientosPageModule)
  },
  {
    path: 'listar-ordenes-medicamentos',
    loadChildren: () => import('./listar-ordenes-medicamentos/listar-ordenes-medicamentos.module').then( m => m.ListarOrdenesMedicamentosPageModule)
  },
  {
    path: 'detalle-orden-medicamento',
    loadChildren: () => import('./detalle-orden-medicamento/detalle-orden-medicamento.module').then( m => m.DetalleOrdenMedicamentoPageModule)
  },
  {
    path: 'crear-orden-intrahospitalaria-pcto',
    loadChildren: () => import('./crear-orden-intrahospitalaria-pcto/crear-orden-intrahospitalaria-pcto.module').then( m => m.CrearOrdenIntrahospitalariaPctoPageModule)
  },
  {
    path: 'crear-orden-intrahospitalaria-mcto',
    loadChildren: () => import('./crear-orden-intrahospitalaria-mcto/crear-orden-intrahospitalaria-mcto.module').then( m => m.CrearOrdenIntrahospitalariaMctoPageModule)
  },
  {
    path: 'detalle-notas-enfermeria',
    loadChildren: () => import('./detalle-notas-enfermeria/detalle-notas-enfermeria.module').then( m => m.DetalleNotasEnfermeriaPageModule)
  },
  {
    path: 'crear-notas-enfermeria',
    loadChildren: () => import('./crear-notas-enfermeria/crear-notas-enfermeria.module').then( m => m.CrearNotasEnfermeriaPageModule)
  },
  {
    path: 'actividades',
    loadChildren: () => import('./actividades/actividades.module').then( m => m.ActividadesPageModule)
  },
  {
    path: 'formatos-diagnosticos',
    loadChildren: () => import('./formatos-diagnosticos/formatos-diagnosticos.module').then( m => m.FormatosDiagnosticosPageModule)
  },
  {
    path: 'detalle-formato',
    loadChildren: () => import('./detalle-formato/detalle-formato.module').then( m => m.DetalleFormatoPageModule)
  },
  {
    path: 'agenda-medica',
    loadChildren: () => import('./agenda-medica/agenda-medica.module').then( m => m.AgendaMedicaPageModule)
  },
  {
    path: 'configuracion',
    loadChildren: () => import('./configuracion/configuracion.module').then( m => m.ConfiguracionPageModule)
  },
  {
    path: 'consultar-citas',
    loadChildren: () => import('./consultar-citas/consultar-citas.module').then( m => m.ConsultarCitasPageModule)
  },
  {
    path: 'solicitar-cita',
    loadChildren: () => import('./solicitar-cita/solicitar-cita.module').then( m => m.SolicitarCitaPageModule)
  },
  {
    path: 'cargar-medicos',
    loadChildren: () => import('./cargar-medicos/cargar-medicos.module').then( m => m.CargarMedicosPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'formato-generico',
    loadChildren: () => import('./formato-generico/formato-generico.module').then( m => m.FormatoGenericoPageModule)
  },
  {
    path: 'listar-formatos-genericos',
    loadChildren: () => import('./listar-formatos-genericos/listar-formatos-genericos.module').then( m => m.ListarFormatosGenericosPageModule)
  },
  {
    path: 'editar-perfil',
    loadChildren: () => import('./editar-perfil/editar-perfil.module').then( m => m.EditarPerfilPageModule)
  },
  {
    path: 'listar-documentos-firmados',
    loadChildren: () => import('./listar-documentos-firmados/listar-documentos-firmados.module').then( m => m.ListarDocumentosFirmadosPageModule)
  },
  {
    path: 'confirmar-token',
    loadChildren: () => import('./confirmar-token/confirmar-token.module').then( m => m.ConfirmarTokenPageModule)
  },
  {
    path: 'crear-orden-externa-pcto',
    loadChildren: () => import('./crear-orden-externa-pcto/crear-orden-externa-pcto.module').then( m => m.CrearOrdenExternaPctoPageModule)
  },
  {
    path: 'listar-ordenes-externas-pcto',
    loadChildren: () => import('./listar-ordenes-externas-pcto/listar-ordenes-externas-pcto.module').then( m => m.ListarOrdenesExternasPctoPageModule)
  },  {
    path: 'crear-orden-externa-mcto',
    loadChildren: () => import('./crear-orden-externa-mcto/crear-orden-externa-mcto.module').then( m => m.CrearOrdenExternaMctoPageModule)
  },
  {
    path: 'listar-ordenes-externas-mcto',
    loadChildren: () => import('./listar-ordenes-externas-mcto/listar-ordenes-externas-mcto.module').then( m => m.ListarOrdenesExternasMctoPageModule)
  },
  {
    path: 'detalle-orden-externa-pcto',
    loadChildren: () => import('./detalle-orden-externa-pcto/detalle-orden-externa-pcto.module').then( m => m.DetalleOrdenExternaPctoPageModule)
  },
  {
    path: 'detalle-orden-externa-mcto',
    loadChildren: () => import('./detalle-orden-externa-mcto/detalle-orden-externa-mcto.module').then( m => m.DetalleOrdenExternaMctoPageModule)
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
